<a *ngIf='fileName' (click)="download()">
    <mat-icon  matTooltipClass="tooltip-bg" matTooltip="Download Document" class="material-icons">get_app</mat-icon>
</a>
